export type Catalogs = "" | "ddf"

export const catalogs: {[key in Catalogs]: string} = {
  "": "UAE",
  "ddf": "UAE"  
}